import React from 'react'
import { Waypoint } from 'react-waypoint'

// Image with Mobile-Desktop-Switch
export interface TrackingProps {
  // Event-Category default:Interactions
  evnt?: string | 'below' | 'above'
  // Event-Type default:vertical-scroll
  action?: string
  // Event-Label
  label?: string
  //
  enterFrom?: string
}
export interface ScrollEventsProps {
  currentPosition: string
  event: Event
  previousPosition: string
  viewportBottom: number
  viewportTop: number
  waypointBottom: number
  waypointTop: number
}
export interface TrackingEventProps {
  gtm?: {
    uniqueEventId?: number
    start?: number
    element?: FormData[]
    elementClasses?: string
    elementTarget?: string
    elementId?: string
    elementUrl?: string
    triggers?: string
  }
  event: string
  event_action?: string
  event_label?: string
  eventCallback?: Function
  eventTimeout?: number
  article_id?: number
  article_title?: string
  article_type?: string
  category?: string
  pagetype?: string
  provider?: string
  publish_date?: number
  subcategory?: string
  type?: string
  uid?: number | undefined
}
interface WindowProps extends Window {
  dataLayer: TrackingEventProps[]
}
declare var window: WindowProps

export const Tracking = ({
  evnt = 'Interactions',
  action = 'vertical-scroll',
  label = '',
  enterFrom = 'below'
}: TrackingProps) => {
  window.dataLayer = window.dataLayer || []

  return (
    <Waypoint
      onEnter={(event: Waypoint.CallbackArgs) => {
        if (
          event.previousPosition === Waypoint[enterFrom] &&
          event.currentPosition === Waypoint.inside
        ) {
          window.dataLayer.push({
            event: evnt,
            event_action: action,
            event_label: label
          })
        }
      }}
    />
  )
}
